import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import CardBody from './CardBody'

const CardWrap = styled(motion.div)`
  position: relative;
  padding: 10px;
  box-shadow: 3px 3px 6px #f3f3f3, 3px 3px 6px #f7f7f7;
  transition: all 0.2s ease-in-out;
  border: 1px solid transparent;
  overflow: hidden;

  &:hover {
    border: 1px solid #ccc;
    box-shadow: 6px 6px 12px #dadada, 6px 6px 12px #f7f7f7;

    @media (hover: none) {
      box-shadow: 3px 3px 6px #f3f3f3, 3px 3px 6px #f7f7f7;
    }
  }

  @media print {
    width: 33%;
    margin-bottom: 32px;
    padding: 0;
    box-shadow: none;
    border: 3px dashed #333;
  }

  > h2 {
    width: 400px;
    margin: 10px;
    padding: 10px;
    text-align: center;

    @media (max-width: 600px) {
      width: 100%;
      margin: 0;
    }

    @media print {
      width: 100%;
    }
  }

  .free {
    background: var(--main-color);
  }

  label {
    &:hover {
      background: var(--main-color-light);
      color: #fff;
    }
  }

  input:checked + label {
    background: var(--main-color);
    color: #fff;
  }
`

const CardHeaderWrap = styled.div`
  margin: 10px 10px 0;

  @media (max-width: 460px) {
    margin: 0;
  }
`

const CardHeader = styled.div`
  display: grid;
  grid-template-columns: 80px 80px 80px 80px 80px;
  text-align: center;

  @media (max-width: 460px) {
    grid-template-columns: 20% 20% 20% 20% 20%;
  }

  @media print {
    margin: 0 6px;
    grid-template-columns: 41px 40px 40px 40px 41px;
  }

  > div {
    padding: 20px;
    border: 1px solid #000;
    font-size: 32px;
    user-select: none;
    background: #f1f1f1;

    @media (max-width: 460px) {
      padding: 10px;
      font-size: 20px;
    }

    @media print {
      padding: 5px;
      font-size: 18px;
    }
  }
`

const Winner = styled(motion.div)`
  position: absolute;
  top: 14px;
  left: -30px;
  transform: rotate(-45deg);
  padding: 5px 26px;
  background: var(--main-color);
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1.5px;
`

const MakeWinner = ({ winner = false }) => {
  return winner && <Winner>Winner</Winner>
}

function MakeCard({ name, number, pattern }) {
  const [winner, setWinner] = useState(false)

  const setWinningCard = useCallback((win) => {
    if (win) {
      setWinner(true)
    } else {
      setWinner(false)
    }
  }, [])

  const generateCardHeader = () => (
    <CardHeader>
      <div>B</div>
      <div>I</div>
      <div>N</div>
      <div>G</div>
      <div>O</div>
    </CardHeader>
  )

  return (
    <CardWrap
      initial={{ opacity: 0, x: 50 }}
      animate={{
        x: 0,
        opacity: 1,
        transition: { delay: number === 1 ? 0 : 0.1 * number },
      }}
    >
      {pattern && <MakeWinner winner={winner} />}
      <h2>{`${name.replace('-', ' ').toUpperCase()}`}</h2>
      <CardHeaderWrap>{generateCardHeader()}</CardHeaderWrap>
      <CardBody name={name} number={number} setWinningCard={setWinningCard} />
    </CardWrap>
  )
}

export default React.memo(MakeCard)
